import { useAuth } from "@/contexts/AuthContext";
import { Navigate, useLocation, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ShieldAlert } from "lucide-react";

export default function ProtectedRoute({ children, requireAdmin = false }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-dvh flex items-center justify-center" data-testid="loading-screen">
                <motion.div
                    animate={{ rotate: 360 }}
                    transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                    className="w-8 h-8 border-2 border-blue-primary border-t-transparent rounded-full"
                />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (requireAdmin && user.role !== "admin") {
        return (
            <div className="min-h-dvh flex items-center justify-center px-6" data-testid="admin-access-denied">
                <div className="rounded-xl border border-rose-200 bg-white p-8 text-center max-w-md shadow-sm">
                    <ShieldAlert size={40} className="text-rose-500 mx-auto mb-4" />
                    <h2 className="font-heading text-xl font-semibold text-slate-900 mb-2">Admin Access Required</h2>
                    <p className="text-slate-500 text-sm mb-5">
                        You don't have permission to access this page. Only administrators can view the admin console.
                    </p>
                    <Link
                        to="/"
                        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-slate-900 text-white text-sm font-medium hover:bg-slate-700 transition-all"
                    >
                        Go to Home
                    </Link>
                </div>
            </div>
        );
    }

    return children;
}
